import { render } from "./option-open.vue?vue&type=template&id=94987f3e&ts=true"
import script from "./option-open.vue?vue&type=script&lang=ts"
export * from "./option-open.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__